module.exports = __webpack_public_path__ + "static/img/smiling-face.52dd054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/smiling-face.png
// module id = 0hsn
// module chunks = 213